import PropTypes from 'prop-types';
import React, { useEffect, useMemo } from 'react';
import AddFutureItems from '../containers/AddFutureItems';
import { MetricFieldSchema } from '../types';
import { translationPrefix } from '../utils';
import FieldGroups from './FieldGroups';
import css from './MetricsPageStep.css';
import StepCard from './StepCard';

const MetricsPageStep = ({
    fields,
    onChange,
    enableAddFuture,
    activeMemberType = '',
    onStepValidationStatusChanged = () => {},
}) => {
    useEffect(() => {
        onStepValidationStatusChanged({ isValid: true, title: '' });
    }, [onStepValidationStatusChanged]);

    const allValues = useMemo(
        () =>
            fields.reduce((total, fieldType) => {
                total.push(...fieldType.values);
                return total;
            }, []),
        [fields]
    );
    const selectedMetricsCount = allValues.filter(value => value.selected).length;
    const totalMetricsCount = allValues.length;

    return (
        <div className={css.container}>
            <StepCard
                className={css.stepCard}
                contentClassName={css.content}
                title={`${translationPrefix}.MANAGE_PERMISSIONS_PAGE.TITLE.METRICS`}
                titleTextReplace={{
                    count: selectedMetricsCount,
                    total: totalMetricsCount,
                }}
                description={`${translationPrefix}.MANAGE_PERMISSIONS_PAGE.DESCRIPTION.${activeMemberType}.METRICS`}
            >
                <FieldGroups
                    fields={fields}
                    allValues={allValues}
                    onChange={onChange}
                    enableAddFuture={enableAddFuture}
                />
            </StepCard>
            <AddFutureItems itemType="metrics" form="selectedMetrics" className={css.addFutureItems} />
        </div>
    );
};

MetricsPageStep.propTypes = {
    fields: PropTypes.arrayOf(MetricFieldSchema.isRequired).isRequired,
    onChange: PropTypes.func.isRequired,
    enableAddFuture: PropTypes.func.isRequired,
    activeMemberType: PropTypes.string,
    onStepValidationStatusChanged: PropTypes.func,
};

export default MetricsPageStep;
